import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const additionalChargeModURL = "api/v1/core-app/additional-charge";

//obtaining the paginated data
export const getAdditionalCharge = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(
    `${additionalChargeModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllAdditionalCharge = () => axiosInstance.get(`${additionalChargeModURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageAdditionalCharge = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(
    `${additionalChargeModURL}/list?offset=${(number - 1) * rowsPerPage}&limit=${rowsPerPage}&ordering=-id`
  );

export const getAdditionalChargeById = (id) => axiosInstance.get(`${additionalChargeModURL}/retrieve/${id}`);

//creating function
export const createAdditionalCharge = (body) => axiosInstance.post(`${additionalChargeModURL}/create`, body);
//updating function
export const updateAdditionalCharge = (id, body) => axiosInstance.patch(`${additionalChargeModURL}/update/${id}`, body);

//searching function
export const handleSearch = (rowsPerPage, search, sortOrder) =>
  axiosInstance.get(
    `${additionalChargeModURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`
  );

// checking the redundant data
export const checkRedundantDataAdditionalChargeName = (e, cancelToken) =>
  axiosInstance.get(`${additionalChargeModURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
